module.exports = __webpack_public_path__ + "img/p2-93.8a58f285.png";